<template>
  <div class="mx-auto w-[90%] rounded-lg py-6">
    <div class="flex justify-between w-full gap-2 mb-2">
      <slot name="top-left">
        <h1 class="flex items-center font-medium text-slate-800">
          {{ title }}
        </h1>
      </slot>
      <div>
        <slot name="top-right" />
        <button
          type="button"
          class="rounded-md bg-[#f6f8fad4] p-2 text-[#808080] outline-none"
          @click="$emit('close', true)"
        >
          <TimesSmall custom-style="size-5" />
        </button>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ModalContainer',

  props: {
    title: {
      type: String,
      default: null,
    },
  },

  emits: ['close'],
}
</script>
